var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.subNavs.length != 0)?_c('div',{staticClass:"subNavs"},[_c('div',{staticClass:"in w1200"},_vm._l((_vm.subNavs),function(item){return _c('router-link',{key:item.path,attrs:{"to":item.path}},[_c('div',{class:{ nav: true, active: _vm.computedActive(item.path) }},[_vm._v(" "+_vm._s(item.name)+" ")])])}),1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }